import Quiz_list from './Quiz_list'

export default Quiz_list